import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ScannerService } from '../../services/scanner.service';
import { UtilityServiceService } from '../../services/utility-service.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';


@Component({
  selector: 'app-list-scanner',
  templateUrl: './list-scanner.component.html',
  styleUrls: ['./list-scanner.component.scss']
})
export class ListScannerComponent implements OnInit {
  vTypes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;  
  lblHeading = '';

  popoverTitle = 'Delete Scanner';
  popoverMessage = 'Are you sure you want to delete Scanner?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Scanner...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private service: ScannerService,private utility: UtilityServiceService,private toastService:ToastNotificationService,private toastr:ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.service.getScanners().subscribe(result => {
      this.vTypes = result;
      this.utility.onSort(1);     
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {
      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Scanner', message: `Scanner ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastService.success(`Scanner ${this.removeRef.device_id} deleted.`,'Delete Scanner');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
      location.reload();

    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Scanner', message: `Scanner ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastService.error(`Scanner ${this.removeRef.device_id} was not deleted.`,'Delete Scanner');

    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Scanner <strong>${this.removeRef.device_id}</strong>?`;        
    this.onChangeHeandig(false);
    this.isRemove = true;

    console.log("listScanners",  this.vTypes);
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Scanners' : 'Delete Scanner';    
  }



}
